import React from "react";
import bus from "../../../admin-bus";
import { MODAL_OPEN } from "../../../action-types";

const assetSelection = ({ option, fetchSelectionData }) => {
  function onEditClick(assetId, e) {
    e.preventDefault();

    window
      .fetch(`/admin/assets/${assetId}/edit`, {
        credentials: "same-origin",
        headers: {
          "X-Requested-With": "XMLHttpRequest"
        }
      })
      .then(response => {
        response.text().then(data => {
          bus.emit(MODAL_OPEN, { content: data, onSuccess: onEditSuccess });
        });
      })
      .catch(error => {
        console.log("Request failed: ", error);
      });
  }

  function onEditSuccess(data) {
    fetchSelectionData();
  }

  return (
    <div className="fba-center" style={{ width: "100%" }}>
      <div style={{ width: "calc(100% - 65px)" }}>
        <p className="mb-xsmall">
          <strong>{option.label}</strong>
        </p>
        <p className="t-xsmall mb-xsmall">
          <span>Default caption: {option.default_caption}</span>
        </p>
        <p className="t-xsmall mb-xsmall">
          <span className="f-mono">
            Uploaded {option.created_at} by {option.uploaded_by_name}
          </span>
        </p>
        {option.published ? (
          <div className="label label--ghost">Published</div>
        ) : (
          <div>
            <p className="t-xsmall mb-xsmall">
              <span className="f-mono">{option.publication_summary}</span>
            </p>
            <div className="label label--warning">
              {option.publication_status}
            </div>
          </div>
        )}
      </div>
      <div style={{ width: "50px", marginLeft: "15px" }}>
        {option.image_url ? (
          <img alt="" style={{ maxWidth: "100%" }} src={option.image_url} />
        ) : (
          ""
        )}
      </div>
      <div className="fl-right ml-medium" style={{ width: "115px" }}>
        <button
          className="button button--xsmall button--primary mr-small"
          onClick={e => onEditClick(option.id, e)}
        >
          Edit asset
        </button>
      </div>
    </div>
  );
};

export default assetSelection;
